import { z } from 'zod';
/**
 * The affixes an item instance may carry (ADR 0057), apart from their
 * catalogue: `items.ts` validates instances with this schema, and
 * `affixes.ts`, which says what each one does, imports `items.ts`.
 */
export const AFFIX_IDS = [
    'dps',
    'health',
    'defence',
    'crit-chance',
    'crit-damage',
    'cooldown',
    'energy',
    'lifesteal',
    'boss-damage',
];
export const AffixIdSchema = z.enum(AFFIX_IDS);
/** The most affixes a piece carries: a legendary's. */
export const MAX_AFFIXES = 3;
/**
 * One affix on one piece. The value is in the affix's own unit: tenths of
 * dps, points of health or defence, percentage points for the rest, tenths of
 * energy a second.
 */
export const AffixSchema = z.object({
    id: AffixIdSchema,
    value: z.number().positive(),
    /** Sealed at the runesmith (ADR 0057): kept as it is at every reroll, for good. */
    sealed: z.literal(true).optional(),
});
export const AffixListSchema = z
    .array(AffixSchema)
    .max(MAX_AFFIXES)
    .refine((list) => new Set(list.map((affix) => affix.id)).size === list.length, {
    message: 'An affix appears once per piece',
});
//# sourceMappingURL=affix-ids.js.map